module.exports = __webpack_public_path__ + "static/media/pastors-header.8bd4f525.jpg";